import React from 'react';

export default function TablePageYearSelect({
    id,
    label = 'Jaar:',
    yearOptions,
    selectedYear,
    onChange,
}) {
    return (
        <>
            <label htmlFor={id}>{label}</label>
            <select id={id} value={selectedYear} onChange={e => onChange(Number(e.target.value))}>
                {yearOptions.map(year => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </>
    );
}
